module.exports = __webpack_public_path__ + "img/d.263de115.png";